'use client';

import React from 'react';
import styled from '@emotion/styled';
import { Link } from '../../../../ui';

interface INewsAlertContentProps {
	body: string;
	url?: string;
}

export const NewsAlertContent = ({ body, url }: INewsAlertContentProps) => (
	<Wrapper>{url ? <StyledLink href={url}>{body}</StyledLink> : body}</Wrapper>
);

const Wrapper = styled.span`
	display: block;
	font-size: 18px;
	line-height: 24px;
	color: rgba(0, 0, 0, 0.87);
	overflow-wrap: anywhere;
	width: 100%;

	& + & {
		margin-top: 8px;
	}
`;

const StyledLink = styled(Link)`
	text-decoration: underline;
	color: rgba(0, 0, 0, 0.87);
`;
